module.exports = __webpack_public_path__ + "img/DIO3000_1-1.42274166.jpg";